export const POLLING_UPDATE_SEC = 60;
export const DB_NAME = 'videoteca';